"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * File navigation.js.
 *
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 */
document.addEventListener("DOMContentLoaded", function (e) {
  navigationInit(); // searchInit();

  catNavigationInit();
  postSliderInit();
  initMaps();
  leteringInit();
  animInit();
  searchNameInit();
});

function navigationInit() {
  var mainMenu = document.querySelector(".main-navigation");
  if (!mainMenu) return;
  var menuToggle = mainMenu.querySelector(".menu-toggle");
  var linksWithChildren = mainMenu.querySelectorAll(".menu-item-has-children");
  menuToggle.addEventListener("click", function (e) {
    document.body.classList.toggle("menu-toggled");

    if (menuToggle.getAttribute("aria-expanded") === "false") {
      menuToggle.setAttribute("aria-expanded", true);
    } else {
      menuToggle.setAttribute("aria-expanded", false);
    }
  });
  linksWithChildren.forEach(function (link, i) {
    // console.log(link);
    var dropDown = document.createElement("button");
    dropDown.setAttribute('aria-label', 'Dropdown');
    dropDown.className = "dropdown-toggle";
    dropDown.addEventListener("click", function (e) {
      link.classList.toggle("active");
    });
    link.prepend(dropDown);
  });
}

function postSliderInit() {
  var sliders = document.querySelectorAll('.is-style-slider');
  var navHtml = '<div class="swiper-button-prev"></div><div class="swiper-button-next"></div>';

  if (typeof Swiper !== 'undefined') {
    console.log('hay slider');
  } else {
    console.log('no hay slider');
  }

  sliders.forEach(function (slider, i) {
    // slider.className += ' swiper posts-slider';
    slider.querySelectorAll('.wp-block-post,.hentry').forEach(function (slide, j) {
      slide.className += ' swiper-slide';
    });
    slider.innerHTML = '<div class="swiper posts-slider"><div class="swiper-wrapper">' + slider.innerHTML + '</div></div>' + navHtml;

    if (i == 0 && typeof Swiper === 'undefined') {
      var swiperScript = document.createElement('script');
      var swiperStyle = document.createElement('link');
      swiperStyle.rel = 'stylesheet';
      swiperScript.src = 'https://cdnjs.cloudflare.com/ajax/libs/Swiper/11.0.5/swiper-bundle.min.js';
      swiperStyle.href = 'https://cdnjs.cloudflare.com/ajax/libs/Swiper/11.0.5/swiper-bundle.css';
      document.head.appendChild(swiperStyle);
      document.head.appendChild(swiperScript);
      swiperScript.addEventListener('load', function (e) {
        enableSlider(slider);
      });
    } else {
      enableSlider(slider);
    }

    function enableSlider(slider) {
      var swiper = new Swiper(slider.querySelector('.swiper'), {
        slidesPerView: 'auto',
        spaceBetween: 8,
        // loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      });
    }
  });
}

function initMaps() {
  var maps = document.querySelectorAll('.acf-map');

  if (!maps.length) {
    console.log('no maps found');
    return;
  }

  ;
  var mapScript = document.createElement('script');
  mapScript.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBYFDtPHwtCtBp5eGq5yNzKEbguSIkUGmU&callback=initMap';

  window.initMap = function () {
    // JS API is loaded and available
    maps.forEach(function (map, i) {
      initMap(map);
    });
  };

  document.head.appendChild(mapScript);

  function initMap(el) {
    // Find marker elements within map.
    var markers = el.querySelectorAll('.marker'); // Create gerenic map.

    var mapArgs = {
      zoom: parseInt(el.dataset.zoom) || 16,
      mapTypeId: google.maps.MapTypeId.ROADMAP
    };
    var map = new google.maps.Map(el, mapArgs); // Add markers.

    map.markers = [];
    markers.forEach(function (marker, i) {
      initMarker(marker, map);
    }); // Center map based on markers.

    centerMap(map); // Return map instance.

    return map;
  }

  function initMarker(marker, map) {
    // Get position from marker.
    var lat = marker.dataset.lat;
    var lng = marker.dataset.lng;
    var latLng = {
      lat: parseFloat(lat),
      lng: parseFloat(lng)
    }; // Create marker instance.

    var gmarker = new google.maps.Marker({
      position: latLng,
      map: map
    }); // Append to reference for later use.

    map.markers.push(gmarker); // If marker contains HTML, add it to an infoWindow.

    if (marker.innerHTML != '') {
      // Create info window.
      var infowindow = new google.maps.InfoWindow({
        content: marker.innerHTML
      }); // Show info window when marker is clicked.

      google.maps.event.addListener(marker, 'click', function () {
        infowindow.open(map, marker);
      });
    }
  }

  function centerMap(map) {
    // Create map boundaries from all map markers.
    var bounds = new google.maps.LatLngBounds();
    map.markers.forEach(function (marker) {
      bounds.extend({
        lat: marker.position.lat(),
        lng: marker.position.lng()
      });
    }); // Case: Single marker.

    if (map.markers.length == 1) {
      map.setCenter(bounds.getCenter()); // Case: Multiple markers.
    } else {
      map.fitBounds(bounds);
    }
  }
}

function leteringInit() {
  // const headings = document.querySelectorAll('h1,.wp-block-heading:not(h1),.wp-block-post-title:not(h1), .fake-title');
  if (document.body.classList.contains('single-project')) {
    return;
  }

  var headings = document.querySelectorAll('h1');
  headings.forEach(function (h, i) {
    lettering(h);
  });
}

function animInit() {
  var gsapScript = document.createElement('script');
  var scrollTriggerScript = document.createElement('script');
  gsapScript.src = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.11.4/gsap.min.js';
  scrollTriggerScript.src = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.11.4/ScrollTrigger.min.js';
  document.head.appendChild(gsapScript);
  gsapScript.addEventListener('load', function () {
    document.head.appendChild(scrollTriggerScript);
  });
  scrollTriggerScript.addEventListener('load', function () {
    // Lettering Anim
    document.querySelectorAll('.lettered .word').forEach(function (word, i) {
      var chars = word.querySelectorAll('.char');
      chars.forEach(function (char, j) {
        gsap.set(char, {
          opacity: 0,
          y: "".concat(gsap.utils.random(-30, 30), "%")
        });
      });
      ScrollTrigger.batch(chars, {
        start: 'top 80%',
        onEnter: function onEnter(batch) {
          // console.log(batch);
          gsap.to(batch, {
            opacity: 1,
            y: 0,
            stagger: 0.05
          }); // console.log(batch.length, "elements entered");
        }
      });
    }); // Paragraphs

    document.querySelectorAll('.entry-content :where(p,li,.wp-block-button)').forEach(function (el, i) {
      gsap.from(el, {
        opacity: 0,
        scrollTrigger: {
          trigger: el,
          start: 'top 80%'
        }
      });
    }); // Images

    document.querySelectorAll('.entry-content :where(.wp-block-image)').forEach(function (el, i) {
      gsap.from(el, {
        opacity: 0,
        scrollTrigger: {
          trigger: el,
          start: 'top 70%'
        }
      });
    });
    document.querySelectorAll('.entry-content :where(.wp-block-media-text__media)').forEach(function (el, i) {
      el.style.overflow = 'hidden';
      gsap.from(el, {
        opacity: 0,
        x: -100,
        duration: 1,
        scrollTrigger: {
          trigger: el // start: 'top 50%',
          // scrub: .5,

        }
      });
      gsap.from(el.querySelector('img'), {
        y: -50,
        scrollTrigger: {
          trigger: el.querySelector('img'),
          // start: 'top 50%',
          scrub: .5
        }
      });
    }); // Hero Cover Home

    document.querySelectorAll('.entry-content > :where(.wp-block-cover.hero-home)').forEach(function (el, i) {
      var parallax = el.querySelector(':where(video,img)');
      gsap.to(el.querySelector('[class*="__inner-container"]'), {
        y: '10%',
        scrollTrigger: {
          trigger: el,
          start: 'top 30%',
          scrub: .25
        }
      }); // console.log(parallax);

      if (parallax) {
        parallax.style.position = 'fixed';
        gsap.to(parallax, {
          y: -50,
          scrollTrigger: {
            trigger: el,
            start: 'top 30%',
            scrub: .25
          }
        });
        ScrollTrigger.create({
          trigger: el,
          start: 'top top',
          onLeave: function onLeave(e) {
            console.log('leave');
            parallax.style.position = '';
          },
          onEnter: function onEnter(e) {
            parallax.style.position = 'fixed';
          },
          onEnterBack: function onEnterBack(e) {
            parallax.style.position = 'fixed';
          }
        });
      }
    }); // Cover Parallax Effects

    document.querySelectorAll('.entry-content > :where(.wp-block-cover:not(:first-child),.wp-block-cover.is-style-page-cover-big,.wp-block-group.has-bckground).alignfull > [class*="inner-container"]').forEach(function (el, i) {
      gsap.to(el, {
        y: '10%',
        scrollTrigger: {
          trigger: el,
          start: 'top 30%',
          scrub: .25
        }
      });
    }); // Loop Items

    ScrollTrigger.batch(document.querySelectorAll('.loop-container > *'), {
      once: true,
      onEnter: function onEnter(batch) {
        gsap.from(batch, {
          opacity: 0,
          y: 10,
          stagger: 0.15
        });
      }
    });
  });
}

function searchInit() {
  var search = document.querySelector('form.wp-block-search');
  if (!search) return;
  var text = search.querySelector('input[type="search"]');
  search.action = window.location;
  text.name = 'search';
}

function catNavigationInit() {
  var catMenus = document.querySelectorAll('.wp-block-categories');
  var dropdownTermsLists = document.querySelectorAll('.terms-list.layout--dropdown');
  var urlParams = new URLSearchParams(window.location.search);
  var catSlug = urlParams.get('project_cat');

  if (catSlug) {
    dropdownTermsLists.forEach(function (el, i) {
      var item = el.querySelector("[value = ".concat(catSlug, "]"));

      if (item) {
        item.selected = 'selected';
      }
    });
  }

  catMenus.forEach(function (catMenu, i) {
    if (catMenu.classList.contains('wp-block-categories-dropdown')) {
      var onCatChange = function onCatChange() {
        if (dropdown.options[dropdown.selectedIndex].value != "") {
          console.log('click!', location);
          location.href = location.origin + location.pathname + "?catId=" + dropdown.options[dropdown.selectedIndex].value;
        }
      };

      // catMenu.querySelector('script').remove();
      var dropdown = document.querySelector('.postform');
      dropdown.onchange = onCatChange;
    }
  });
  dropdownTermsLists.forEach(function (el, i) {
    el.onchange = function () {
      console.log(el.options[el.selectedIndex].value);

      if (el.options[el.selectedIndex].value != null) {
        location.href = "./?".concat(el.name, "=").concat(el.options[el.selectedIndex].value);
      }
    };
  });
}

function searchNameInit() {
  var searchForms = document.querySelectorAll('form.wp-block-search'); // const dropdownTermsLists = document.querySelectorAll('.terms-list.layout--dropdown')

  var urlParams = new URLSearchParams(window.location.search); // const catSlug = urlParams.get('project_cat');
  // if (catSlug) {
  // 	dropdownTermsLists.forEach((el, i) => {
  // 		let item = el.querySelector(`[value = ${catSlug}]`);
  // 		if (item) {
  // 			item.selected = 'selected';	
  // 		}
  // 	})
  // }

  searchForms.forEach(function (form, i) {
    var input = form.querySelector('input[type="search"]');
    if (!input) return;
    console.log(input);
    form.action = window.location;
    input.name = 'search'; // form.addEventListener('submit', (e) => {
    // 	e.preventDefault();
    // 	// console.log(e,input.value);
    // 	// console.log(urlParams);
    // 	location.href = `./?s=${el.value}`;
    // })
  }); // dropdownTermsLists.forEach((el, i) => {
  // 	el.onchange = () => {
  // 		console.log(el.options[el.selectedIndex].value);
  // 		if (el.options[el.selectedIndex].value != null) {
  // 			location.href = `./?${el.name}=${el.options[el.selectedIndex].value}`;
  // 		}
  // 	}
  // })
}
/*--------------------------------------------------------------
## Lettering script
--------------------------------------------------------------*/


function lettering(el) {
  var text = el;
  var newHTML = "";
  var start = 0;
  /**
   * the idea is to select all the opening and closing html tags
   * and reverse that to get everything but tags using substrigs indexation and tags length
   * Once done this it wraps each word an non-space char
   * with a span tags.
   * 
   * Useful when you have inner tags like <br>, <strong> or <a> inside texts :)
   * 
   */
  // pattern to find all the tags, including its content and attributes.

  var reg = /<\/?\w+\s*[a-zA-Z|0-9|#|?|¿|!|¡|=|"|/|_|\-|/.|:|\s]*>/g;

  var matchs = _toConsumableArray(text.innerHTML.matchAll(reg));

  if (matchs.length > 0) {
    // console.log('has children');
    matchs.forEach(function (match, i) {
      var end = match.index - start;
      var trimmedText = decodeHTML(match.input.substr(start, end));
      trimmedText = splitText(trimmedText);
      newHTML += trimmedText + match[0];
      start = match.index + match[0].length;

      if (matchs.length == i + 1) {
        var lastPiece = decodeHTML(match.input.substr(start));
        console.log('last!', {
          start: start,
          lastPiece: lastPiece,
          input: match.input
        });
        newHTML += splitText(lastPiece);
      }
    });
    text.innerHTML = newHTML;
  } else {
    text.innerHTML = splitText(decodeHTML(text.innerHTML));
  }

  text.classList.add('lettered'); // where wrapping happens...

  function splitText(t) {
    t = t.replace(/\S+/g, function (m) {
      return "<span class='word'style=\"display:inline-block;\">" + m.replace(/./g, function (n) {
        return "<span class='char " + n + "'style=\"display:inline-block;\">" + n + "</span>";
      }) + "</span>";
    });
    return t;
  }
  /**
   * a quite elegant way to decode html entities!
   */


  function decodeHTML(html) {
    var txt = document.createElement('textarea');
    txt.innerHTML = html;
    return txt.value;
  }

  ;
}